import { Container } from 'inversify'
import { Locale } from './Core/Locale'
import { MessagesRepository } from './Core/Messages/MessagesRepository'
import { RouterRepository } from './Routing/RouterRepository'
import { UserModel } from './Authentication/UserModel'
import { NavigationRepository } from './Navigation/NavigationRepository'
import { ProductListRepository } from './Products/ProductListRepository'
import { ProductDetailRepository } from './Products/ProductDetailRepository'

export class BaseIOC {
  container

  constructor() {
    this.container = new Container({
      autoBindInjectable: true,
      defaultScope: 'Transient'
    })
  }

  buildBaseTemplate = () => {
    this.container.bind(Locale).to(Locale).inSingletonScope()
    this.container.bind(ProductDetailRepository).to(ProductDetailRepository).inSingletonScope()
    this.container.bind(ProductListRepository).to(ProductListRepository).inSingletonScope()
    this.container.bind(MessagesRepository).to(MessagesRepository).inSingletonScope()
    this.container.bind(RouterRepository).to(RouterRepository).inSingletonScope()
    this.container.bind(NavigationRepository).to(NavigationRepository).inSingletonScope()
    this.container.bind(UserModel).to(UserModel).inSingletonScope()
    return this.container
  }
}
 
